import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQDivider from '../../components/divider';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import { BREADCRUMB_ROOT } from '../../common/config';

const attributes = [
  { attribute: 'vertical', type: 'boolean', default: 'false', description: 'If true, renders a vertical divider.' },
  { attribute: 'className', type: 'string', default: "''", description: 'Additional class names.' },
  { attribute: 'style', type: 'React.CSSProperties', default: 'undefined', description: 'Inline styles.' },
];

const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
  { columnId: 'attribute', renderHeaderCell: () => 'Attribute', renderCell: (item) => item.attribute },
  { columnId: 'type', renderHeaderCell: () => 'Type', renderCell: (item) => <code>{item.type}</code> },
  { columnId: 'default', renderHeaderCell: () => 'Default', renderCell: (item) => <code>{item.default}</code> },
  { columnId: 'description', renderHeaderCell: () => 'Description', renderCell: (item) => item.description },
];

const codeExample = `
import UQDivider from '@uniqconsulting/ui/components/divider';

<UQDivider />

<div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
  <span>Left</span>
  <UQDivider vertical />
  <span>Right</span>
</div>
`;

const DividerDemoPage = () => (
  <>
    <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Divider']} />
    <h1>UQDivider Demo</h1>
    <UQSpacer size="m" />

    <h2>Description</h2>
    <p>
      <code>UQDivider</code> is used to visually separate content. It supports both horizontal and vertical orientations.
    </p>
    <UQSpacer size="m" />

    <h2>Attributes</h2>
    <UQSpacer size="s" />
    <UQDataGrid
      items={attributes}
      columns={attributeColumns}
      sortable={false}
      selectionMode="none"
      rowLines
    />
    <UQSpacer size="m" />

    <h2>Examples</h2>
    <UQSpacer size="s" />
    <div>
      <div>Section 1</div>
      <UQDivider />
      <div>Section 2</div>
    </div>
    <UQSpacer size="m" />
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <span>Left</span>
      <UQDivider vertical />
      <span>Right</span>
    </div>
    <UQSpacer size="m" />

    <h2>Code Example</h2>
    <UQCode code={codeExample.trim()} enableCopy />
  </>
);

export default DividerDemoPage;